import { useState } from "react";
import type { FormEvent } from "react";

const FORM_ADDR = "https://readdy.ai/api/form/db96gn1rh5tg6sock440";

export default function ContactForm() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [message, setMessage] = useState("");
  const [length, setLength] = useState(0);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const formEl = event.currentTarget;
    const formData = new FormData(formEl);
    const honeypot = String(formData.get("phone_alt") ?? "").trim();
    if (honeypot) {
      setStatus("success");
      setMessage("提交成功，感谢你的反馈！");
      formEl.reset();
      setLength(0);
      return;
    }
    formData.delete("phone_alt");
    setStatus("loading");
    setMessage("");
    try {
      const response = await fetch(FORM_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed: { code?: string; message?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || "";
      const isSpam = String(serverMsg).toLowerCase().includes("spam");
      if (response.ok && parsed?.code === "OK" && !isSpam) {
        setStatus("success");
        setMessage("提交成功，感谢你的反馈！");
        formEl.reset();
        setLength(0);
      } else {
        setStatus("error");
        setMessage(serverMsg || "提交失败，请稍后再试。");
      }
    } catch (err) {
      setStatus("error");
      setMessage(err instanceof Error ? err.message : "网络异常，请稍后再试。");
    }
  };

  const inputClass =
    "w-full px-4 py-2.5 text-sm rounded-md bg-background-50 border border-background-200 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400";

  return (
    <form onSubmit={handleSubmit} data-readdy-form id="contact-feedback-form" className="space-y-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label htmlFor="contact-name" className="block text-sm text-foreground-700 mb-1.5">
            你的称呼
          </label>
          <input id="contact-name" type="text" name="name" required placeholder="请输入称呼" className={inputClass} />
        </div>
        <div>
          <label htmlFor="contact-email" className="block text-sm text-foreground-700 mb-1.5">
            邮箱地址
          </label>
          <input id="contact-email" type="email" name="email" required placeholder="用于接收回复" className={inputClass} />
        </div>
      </div>
      <div>
        <label htmlFor="contact-message" className="block text-sm text-foreground-700 mb-1.5">
          反馈内容
        </label>
        <textarea
          id="contact-message"
          name="message"
          required
          maxLength={500}
          rows={4}
          onChange={(e) => setLength(e.target.value.length)}
          placeholder="请描述你的建议、内容纠错或合作意向（500 字以内）"
          className={`${inputClass} resize-none`}
        />
        <p className="mt-1 text-xs text-foreground-400 text-right">{length} / 500</p>
      </div>
      <input
        type="text"
        name="phone_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
        className="verify-field-extra"
      />
      <div className="flex flex-wrap items-center gap-4">
        <button
          type="submit"
          disabled={status === "loading"}
          className="px-6 py-2.5 rounded-md bg-accent-500 text-primary-950 text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer disabled:opacity-60"
        >
          {status === "loading" ? "提交中..." : "提交反馈"}
        </button>
        {message && (
          <span
            role="status"
            className={`text-sm ${status === "success" ? "text-primary-600" : "text-accent-700"}`}
          >
            {message}
          </span>
        )}
      </div>
    </form>
  );
}